import React, { useState, useRef, useEffect } from 'react';
import './RightCart.scss';
import close from "../../../assets/close.svg"
import { useDispatch, useSelector } from 'react-redux';
import IMAGE_PLACEHOLDER from "../../../assets/images/Images/empty-placeholder.png"
import { useHistory } from 'react-router';
import { getCurrencyFormat, getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from '../../../../../../utilities/helper';
import { addToCart, deleteCart, deleteCartItem, getCartItemsToCart, predictPrice, updateCartItemQuantity, updateOrderTypeDetails } from '../../../../RestaurantWidget/utilities/api/restaurantsService';
import { setOrderCartItems, setOrderData, setOrderDataPayment, setOrderEmpty, setSelectedOrderType } from '../../../../../../../../redux/resturantWidgetSlice';
import { v4 as uuidv4 } from 'uuid';
import deleteIcon from "../../../assets/deleteIC.svg"
import DeletePopup from '../../Cart/DeletePopup';
import cart from "../../../assets/cart-filled.svg"
import time from "../../../assets/clock-filled.svg"

import { setSelectedOffer } from '../../../../../../../../redux/companyDataSlice';
import { getRestaurantMenuSettingsData } from '../../../../../../utilities/apiRequests/neutriPosServerRequests';
import { getOrderTypeData, RESTAURANT_SETTINGS_TYPES } from '../../../../../../utilities/restaurantMenuUtil';
import moment from 'moment';

const RightCart = ({ isOpen, setIsOpen, setCheckoutFailed, isStoreOpen, setIsStoreClosed, setIsStoreOrderBlocked, setIsScheduleError, setIsScheduleTimeError, isMobile, suggestedItems }) => {
    const containerRef = useRef(null);
    const suggestContainerRef = useRef(null)
    const [height, setHeight] = useState(0);
    const [isDeleteItem, setIsDeleteItem] = useState("")
    const [isLoading, setIsLoading] = useState("")
    const [isAddLoading, setIsAddLoading] = useState("")

    const [isCheckLoading, setIsCheckLoading] = useState("")
    const [isDeleteLoading, setIsDeleteLoading] = useState(false)
    const storeClosed = useSelector((state) => state.companyData.storeClosed);

    const history = useHistory();
    const dispatch = useDispatch()

    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);




    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;
    const currencyFormat = getCurrencyFormat(restaurantDataState.currency);
    const acceptOrders = companyDetails?.settings?.OnlineOrder?.AcceptOrders || true
    const enableSchdeulOrders = companyDetails?.settings?.EnableScheduledOrder || false

    const toggleDrawer = () => { setIsOpen(!isOpen) };



    const isBlockedHour = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const today = companyDetails?.settings?.OnlineOrder?.BlockedHours.find(day => day.Day === currentDay);
        if (!today) return false;

        for (let hours of today.Time) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }
        return false;
    }
    useEffect(() => {
        if (containerRef.current) {
            let blockHeight = !enableSchdeulOrders ? isBlockedHour() || !isStoreOpen() ? storeClosed[selectedOrderType] ? 150 : 65 : 0 : !isStoreOpen() ? 65 : 0
            const suggesCont = suggestContainerRef.current ? suggestContainerRef?.current?.getBoundingClientRect().height : 0
            const measuredHeight = containerRef.current.getBoundingClientRect().height + 65 + blockHeight + suggesCont;
            setHeight(`calc(100% -  ${measuredHeight}px)`);
        } else {
            setHeight("100%")
        }


    }, [isOpen, restaurantDataState.orderCartData, suggestedItems]);

    const getCartSubTotal = () => {
        return restaurantDataState?.orderDetails?.Payment?.
            PaymentDetail?.ItemCharges?.Gross?.Formatted ?? "£ 0.00"

    }
    const getCartTotal = () => {
        return restaurantDataState?.orderDetails?.Payment?.
            PaymentDetail?.OrderTotal?.Gross?.Formatted ?? "£ 0.00"

    }
    const getTotal = (data) => {
        let responsePrice = data?.Gross?.AmountE5
        let totalPrice = restaurantDataState?.orderDetails?.Payment?.
            PaymentDetail?.OrderTotal?.Gross?.AmountE5 + responsePrice
        return {
            AmountE5: totalPrice,
            Formatted: `£${(totalPrice / 100).toFixed(2)}`,
            CurrencyCode: "GBP"
        }
    }
    const onCheckoutClickRestaurant = () => {
        if (restaurantDataState.orderDetails.FulfillmentType === "DELIVERY_BY_REWARDCONSUMER") {
            let data = {
                "CloudLocationID": JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID,
                "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID),
                "ReferenceNo": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID)
            }
            predictPrice(data).then((response) => {

                if (response) {
                    let dataRes =
                    {
                        Details: response.Details,
                        Total: getTotal(response.Total)
                    }
                    setIsCheckLoading(false)

                    dispatch(setOrderDataPayment(dataRes))
                    history.push('/order/checkout');
                } else {
                    setIsCheckLoading(false)
                    history.push('/order/checkout');
                }
            }).catch((error) => {
                if (error.response.status === 404) {
                    setIsCheckLoading(false)
                    setCheckoutFailed(error.response.data.Result)
                } else {
                    setIsCheckLoading(false)


                }
            })
        } else {
            history.push('/order/checkout');
        }

    };
    const updateTotalPrice = (price, quantity) => {
        const createPriceObj = (priceValue, quantity) => ({
            Amount: priceValue * quantity,
            FormattedText: currencyFormat((priceValue * quantity) / 100),
            FormattedAmount: Number(((priceValue * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });
        const totalPrice = getPriceData(price, quantity);
        return totalPrice
    }
    const increaseQty = (item) => {
        setIsLoading(item.ID)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount + 1,
            "CountryISOCode": "GB"
        }
        const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
            itemValue.ID === item.ID
                ? {
                    ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount + 1 }, PriceInfo: {
                        ...itemValue.PriceInfo,
                        BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount + 1),
                        TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount + 1)

                    }
                }
                : itemValue
        );
        dispatch(setOrderCartItems(updatedArray))
        updateCartItemQuantity(data).then((response) => {
            if (window.location.pathname.includes(item.ID)) {
                let found = response.Carts.Items.find((val) => val.ID === item.ID)
                const cartItem = found ? found : response.Carts.Items[response.Carts.Items.length - 1]
                const quantities = reduceQuantity([cartItem])
                const updatQty = assignIdsAndParentIds(quantities)
                localStorage.setItem("QUANTITY", JSON.stringify([updatQty]))

                history.push('/item/' + cartItem.CartItemID + "/" + item.ID)


            }
            dispatch(setOrderData(response))
            setIsLoading("")
        })
    }
    const decreaseQty = (item) => {
        setIsLoading(item.ID)

        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount - 1,
            "CountryISOCode": "GB"
        }
        if (data.NewQuantity > 0) {
            const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
                itemValue.ID === item.ID
                    ? {
                        ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount - 1 }, PriceInfo: {
                            ...itemValue.PriceInfo,
                            BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount - 1),
                            TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount - 1),
                        }
                    }
                    : itemValue
            );
            dispatch(setOrderCartItems(updatedArray))
            updateCartItemQuantity(data).then((response) => {
                if (window.location.pathname.includes(item.ID)) {
                    let found = response.Carts.Items.find((val) => val.ID === item.ID)
                    const cartItem = found ? found : response.Carts.Items[response.Carts.Items.length - 1]
                    const quantities = reduceQuantity([cartItem])
                    const updatQty = assignIdsAndParentIds(quantities)
                    localStorage.setItem("QUANTITY", JSON.stringify([updatQty]))

                    history.push('/item/' + cartItem.CartItemID + "/" + item.ID)

                }
                dispatch(setOrderData(response))

                setIsLoading("")

            })

        } else {
            let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== item.ID)
            dispatch(setOrderCartItems(cartArray))
            deleteCartItem(item.ID).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCart(customerID, cloud).then((response) => {
                            if (response) {
                                dispatch(setOrderData(response))

                            }
                        })
                        setIsDeleteItem("")
                    }
                    else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    if (window.location.pathname.includes(item.ID)) {

                        history.push("/")
                    }
                    setIsLoading("")
                }
            })
        }
    }
    const deleteItem = () => {
        if (isDeleteItem !== "" && !isDeleteLoading) {
            setIsDeleteLoading(true)
            deleteCartItem(isDeleteItem).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCart(customerID, cloud).then((response) => {
                            if (response) {
                                dispatch(setOrderData(response))

                            }
                        })
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    if (window.location.pathname.includes(isDeleteItem)) {

                        history.push("/")

                    }
                    setIsDeleteLoading(false)
                }
            })
        }
    }


    const getPrice = (
        baseTotalPrice
    ) => {
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = baseTotalPrice.Delivery.FormattedText;
                break;
            case "table":
                priceValue = baseTotalPrice.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = baseTotalPrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = baseTotalPrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }
    const getItemPrice = (baseUnit, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery?.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway?.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn?.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });

        return getPriceData(baseUnit || {}, quantity);
    };
    const assignIdsAndParentIds = (cartItem) => {
        const recursiveAssign = (item, parentId = null) => {
            item.ValueID = item.ValueID || uuidv4();

            if (parentId) {
                item.ParentID = parentId;
            }

            if (Array.isArray(item.SelectedModifierGroups)) {
                item.SelectedModifierGroups.forEach(group => {
                    group.ParentID = item.ValueID;

                    if (Array.isArray(group.SelectedItems)) {
                        group.SelectedItems.forEach(subItem => {
                            recursiveAssign(subItem, group.ParentID);
                        });
                    }
                });
            }
        };

        recursiveAssign(cartItem);
        return cartItem;
    };
    const reduceQuantity = (quantities) => {
        if (!quantities.length) return;

        const updateSelectedItems = (selectedItems, multiplier) => {
            return selectedItems.map(itemVal => {
                let updatedAmount = itemVal.Quantity.Amount / multiplier;
                let newAmount = Number.isInteger(updatedAmount) ? updatedAmount : Math.round(updatedAmount);

                return {
                    ...itemVal,
                    Quantity: {
                        ...itemVal.Quantity,
                        Amount: newAmount
                    },
                    PriceInfo: {
                        ...itemVal.PriceInfo,
                        BaseTotalPrice: getItemPrice(itemVal.PriceInfo.BaseUnitPrice, newAmount)
                    },
                    SelectedModifierGroups: itemVal.SelectedModifierGroups.map(group => ({
                        ...group,
                        SelectedItems: updateSelectedItems(group.SelectedItems, multiplier)
                    }))
                };
            });
        };

        const parentItem = { ...quantities[0] };

        return {
            ...parentItem,
            SelectedModifierGroups: parentItem.SelectedModifierGroups.map(group => ({
                ...group,
                SelectedItems: updateSelectedItems(group.SelectedItems, parentItem.Quantity.Amount)
            }))
        };
    };
    const getOrderType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
            case "table":
                type = "DINE_IN";
                break;
            case "collection":
                type = "TAKE_AWAY";
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
        }
        return type
    }
    const getItemPriceForCart = (option, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: "GB"
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);
        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const addItemToCart = async (selectedItem) => {
        setIsAddLoading(selectedItem.MenuItemID)
        setIsLoading(selectedItem.MenuItemID)

        const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
        const userDetails = localStorage.getItem('fullUserDetails')
        let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
        let customer = {
            ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            Name: {
                DisplayName: userDetails ? parsedUserDetails.UserName : "",
                FirstName: userDetails ? parsedUserDetails.FirstName : "",
                LastName: userDetails ? parsedUserDetails.LastName : "",
            },
            Email: userDetails ? parsedUserDetails.Email : "",
            IsPrimaryCustomer: true

        }
        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        let cartObject = {
            "CartItemID": selectedItem.MenuItemID,
            "Title": selectedItem.Title?.en,
            "CustomerID": customerID,
            "Quantity": {
                "Unit": "pcs",
                "Amount": 1
            },
            "DefaultQuantity": {
                "Amount": 1,
                "Unit": "pcs"
            },
            "CustomerRequests": {
                "Allergy": {
                    "Allergens": [],
                    "Instructions": ""
                },
                "SpecialInstructions": ""
            },
            SelectedModifierGroups: [],
            ValueID: uuidv4(),
            ID: "",
            ModifierGroupRules: selectedItem.ModifierGroupRules,
            Image: selectedItem.ImageURL,
            PriceInfo: getItemPriceForCart(selectedItem.PriceInfo, 1)

        }
        let cart = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : '',
            "StoreID": val.cloudLocationID,
            "ConsumerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            "OrderingPlatformType": "RETAILPACX",
            "CountryISOCode": "GB",
            "OrganizationID": val.organizationID,
            "CloudLocationID": val.cloudLocationID,
            "Name": companyDetails.shopName,
            "OrderFullFilmentType": getOrderType(),
            "Customers": [customer],
            Cart: cartObject
        }
        await addToCart(cart).then((res) => {
            if (res) {
                getCartItemsToCart(customerID, val.cloudLocationID).then((response) => {
                    if (response) {
                        dispatch(setOrderData(response))
                        setIsAddLoading("")
                        setIsLoading("")

                    }
                })
            }
        })
    }
    // const deleteCartAll = () => {
    //     setIsLoading("00000")
    //     dispatch(setOrderCartItems([]))
    //     deleteCart().then((response) => {
    //         if (response) {
    //             dispatch(setOrderEmpty())
    //             
    //             setIsLoading("")


    //         } else {
    //             setIsLoading("")
    //         }
    //     })
    // }
    const updateOrderType = async (typeValue) => {
        const orderID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID);

        if (!orderID) return;

        const body = {
            OrderID: orderID,
            DeliveryType: typeValue,
            CountryCode: "GB",
        };

        try {
            const response = await updateOrderTypeDetails(body);
            dispatch(setOrderData(response));
        } catch (error) {
            console.error("Failed to update order type:", error);
        }
    };

    const handleUpdateOrder = async () => {
        const orderTypes = [
            { type: "collection", typeValue: "TAKE_AWAY" },
            { type: "delivery", typeValue: "DELIVERY_BY_REWARDCONSUMER" },
            { type: "table", typeValue: "DINE_IN" },
        ];

        const matchedType = orderTypes.find((val) => val.type === selectedOrderType);

        if (matchedType && restaurantDataState.orderDetails.FulfillmentType !== matchedType.typeValue) {
            dispatch(setSelectedOrderType(matchedType.type))
            await updateOrderType(matchedType.typeValue);
        }
    };

    return (
        <div className='RightCart'>

            <div className={`right-drawer-cart-v3`} style={{ height: window.screen.width > 1200 ? `calc(100vh - 80px)` : '100dvh' }}>

                <div className="drawer-header">
                    {isMobile && < img alt='' src={close} className="close-button" onClick={toggleDrawer} />}

                    <div className='right-drawer-header'>Shopping Cart</div>
                </div>
                {!enableSchdeulOrders ? <> {isBlockedHour() || !isStoreOpen() ?
                    <div className='order-closed'>Our store is currently closed for orders. We'll be back soon to serve you better.</div> : ""}
                    {storeClosed[selectedOrderType] &&
                        <div className="current-status-cont">
                            <div className="current-status-cont-header-cont">
                                <img alt="" src={time} className="header-cont-icon" />
                                <div className="header-cont-title ">Current Status</div>
                            </div>
                            <div className="current-status-cont-sub">
                                Sorry, We're currently closed for {selectedOrderType}.</div>
                        </div>}

                </> : !isStoreOpen() && <div className='order-closed'>Our store is currently closed for orders. We'll be back soon to serve you better.</div>}
                <div className='cart-mid-cont' style={{ height }}>
                    {isCartDataAvailable && restaurantDataState.orderCartData.Items.length > 0 ? restaurantDataState.orderCartData.Items.map((item, key) => {

                        return (
                            <div className='item-container' key={key} >
                                <img onClick={() => {
                                    const quantities = reduceQuantity([item])
                                    const updatQty = assignIdsAndParentIds(quantities)
                                    localStorage.setItem("OFF_QT", JSON.stringify([updatQty]))
                                    dispatch(setSelectedOffer(`${item.CartItemID}/${item.ID}`))

                                }} alt=''
                                    className='item-img-content'
                                    src={item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER} />
                                <div className='item-content'>
                                    <div className='item-title'>{item.Title.toCapitalFirst().replace(/\.+$/, '')}</div>
                                    <div className='item-price-val'>{isLoading === item.ID ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "20px" }}>
                                        {getPrice(item.PriceInfo.TotalPrice)}XXX</div>
                                        : getPrice(item.PriceInfo.TotalPrice)}</div>

                                </div>
                                <div className='item-qty-container'>

                                    {item.Quantity.Amount > 1 ? <div className='qty-ic-cont' onClick={() => {
                                        decreaseQty(item)
                                    }}>-</div> :
                                        <img alt='' className='delete-item-ic' src={deleteIcon}
                                            onClick={() => {
                                                setIsDeleteItem(item.ID)
                                            }} />}
                                    <div className='qty-cont-val'> {item.Quantity.Amount}</div>
                                    <div className='qty-ic-cont' onClick={() => {
                                        increaseQty(item)
                                    }}>+</div>
                                </div>

                            </div>
                        )
                    }) : <div className='empty-cart-cont'>
                        <img alt='' src={cart} className='empty-cart-ic' />
                        <div className='empty-cart-text'>Your cart is empty</div>
                    </div>}
                </div>
                {
                    suggestedItems?.length > 0 && isCartDataAvailable && restaurantDataState?.orderCartData?.Items.length > 0 &&
                    <div className='suggested-items' ref={suggestContainerRef}>
                        <div className='suggested-items-header'>Suggested for you
                        </div>
                        <div className='suggested-items-list'>
                            {suggestedItems?.map((item, key) => {
                                return (
                                    <div key={key} className='suggested-items-list-item'>
                                        <img
                                            alt=''
                                            src={item?.ImageURL ? item?.ImageURL : IMAGE_PLACEHOLDER}
                                            className='suggested-items-list-item-img' />
                                        <div className='suggested-items-list-item-det'>

                                            <div className='suggested-items-list-item-det-title'>
                                                {item?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}
                                            </div>
                                            <div
                                                className='suggested-items-list-item-det-add-btn'
                                                onClick={() => addItemToCart(item)}
                                            >
                                                {isAddLoading === item.MenuItemID ? (
                                                    <>
                                                        <div className='loader-btn' />
                                                        Adding
                                                    </>
                                                ) : (
                                                    '+ Add'
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                )
                            })}
                        </div>
                    </div>
                }
                {isCartDataAvailable && restaurantDataState?.orderCartData?.Items.length > 0 && <div className='cart-btm-cont' ref={containerRef}>
                    <div className='cart-payment-amount-cont'>
                        <div className='pymt-amnt-tag'>Subtotal</div>
                        <div className='pymt-amnt'>{isLoading !== "" ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "21px" }}>XXXXXXXXXX</div> : getCartSubTotal()}</div>
                    </div>
                    {restaurantDataState?.orderDetails?.Payment?.
                        PaymentDetail?.Fee?.Details?.map((fee, key) => {
                            return (
                                <div className='cart-payment-amount-cont' key={key}>
                                    <div className='pymt-amnt-tag'>{fee.Description}</div>
                                    <div className='pymt-amnt'>
                                        {fee.Amount.DisplayAmount}
                                    </div>
                                </div>
                            )
                        })}
                    {restaurantDataState?.orderDetails?.Payment?.
                        PaymentDetail?.Promotions?.Detail?.length > 0 && restaurantDataState?.orderDetails?.Payment?.
                            PaymentDetail?.Promotions?.Detail?.map((fee, key) => {
                                return (
                                    <div className='cart-payment-amount-cont' key={key}>
                                        <div className='pymt-amnt-tag'>Promotion
                                            <span className='pymt-amnt-tag-dis'>{fee?.DiscountPercentage}% off</span>
                                        </div>
                                        <div className='pymt-amnt-dis'>
                                            - {currencyFormat(fee?.SavingsAmount / 100)}
                                        </div>
                                    </div>
                                )
                            })}
                    {/* <div className='cart-payment-amount-cont'>
                        <div className='pymt-amnt-tag'>Estimated Delivery Time</div>
                        <div className='pymt-amnt'>25-25 mins</div>
                    </div> */}
                    <div className='cart-payment-amount-cont'>
                        <div className='total-amnt-tag'>Total</div>
                        <div className='total-amnt'>{isLoading !== "" ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "28px" }}>XXXXXXXXXX</div> : getCartTotal()}</div>
                    </div>
                    <div className={enableSchdeulOrders ? 'cart-pymnt-btn' : storeClosed[selectedOrderType] ? 'cart-pymnt-btn-disable' : isCartDataAvailable ? acceptOrders ? !isBlockedHour() ? 'cart-pymnt-btn' : 'cart-pymnt-btn-disable ' : 'cart-pymnt-btn-disable ' : 'cart-pymnt-btn-disable '}
                        onClick={async () => {
                            if (isLoading === "" && !isCheckLoading) {
                                setIsCheckLoading(true)
                                let locID = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                                let _cloudLocations = [{
                                    CloudLocationID: locID,
                                    CloudLocationName: "",
                                }]
                                const _orderTypeData = await getOrderTypeData(_cloudLocations);
                                const defaultLocOrder = _orderTypeData.find(array =>
                                    array.some(item => item.CloudLocationID === locID)
                                )
                                const _orderTypeNames = defaultLocOrder ? defaultLocOrder.map(_item => _item.OrderTypeName) : [...new Set(_orderTypeData.flat().map(_item => _item.OrderTypeName))];
                                const _defaultOrderType = defaultLocOrder ? defaultLocOrder.find(item => item.IsDefault) : _orderTypeData.flat().find(item => item.IsDefault);
                                let storedData = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA);
                                await setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA, {
                                    ...storedData,
                                    defaultOrderType: _defaultOrderType.OrderTypeName,
                                    orderTypes: _orderTypeNames,
                                    selectedOrderType: selectedOrderType
                                });
                                await setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA, {
                                    ...storedData,
                                    defaultOrderType: _defaultOrderType.OrderTypeName,
                                    orderTypes: _orderTypeNames,
                                    selectedOrderType: selectedOrderType

                                });
                                await handleUpdateOrder()
                                if (_orderTypeNames.includes(selectedOrderType)) {
                                    if (enableSchdeulOrders) {
                                        const sched = localStorage.getItem("schedule_order")
                                        if (sched) {
                                            const startTime = JSON.parse(localStorage.getItem("schedule_order")).StartTime.replace('Z', '')
                                            const hasPassed = moment().isAfter(moment(startTime));
                                            if (!hasPassed) {
                                                if (isCartDataAvailable) {
                                                    if (isLoading === "" && !isCheckLoading) {
                                                        onCheckoutClickRestaurant()
                                                    }
                                                }
                                            } else {
                                                setIsScheduleTimeError(true)
                                                setIsCheckLoading(false)

                                            }
                                        } else {
                                            if ((!storeClosed[selectedOrderType] && !isBlockedHour() && acceptOrders)) {
                                                if (isStoreOpen()) {
                                                    if (isCartDataAvailable) {
                                                        if (isLoading === "" && !isCheckLoading) {
                                                            onCheckoutClickRestaurant()
                                                        }
                                                    }
                                                } else {
                                                    setIsScheduleError(true)
                                                    setIsCheckLoading(false)


                                                }
                                            } else {
                                                setIsScheduleError(true)
                                                setIsCheckLoading(false)

                                            }
                                        }
                                    } else {
                                        if ((!storeClosed[selectedOrderType] && !isBlockedHour() && acceptOrders)) {
                                            if (isStoreOpen()) {
                                                if (isCartDataAvailable) {
                                                    if (isLoading === "" && !isCheckLoading) {
                                                        onCheckoutClickRestaurant()
                                                    }
                                                }
                                            } else {
                                                setIsStoreClosed(true)
                                                setIsCheckLoading(false)


                                            }
                                        } else {
                                            setIsStoreClosed(true)
                                            setIsCheckLoading(false)

                                        }
                                    }
                                } else {
                                    setIsCheckLoading(false)

                                    setIsStoreOrderBlocked(true)

                                }
                            }
                        }} >
                        {isCheckLoading &&
                            <div className='loader-btn' />}
                        Proceed to Checkout
                    </div>
                </div>}
            </div>
            <DeletePopup
                visibility={isDeleteItem !== ""}
                onPopupClose={() => {
                    setIsDeleteItem("")
                }}
                onDeleteConfirm={deleteItem}
                isLoading={isDeleteLoading} />
        </div>
    );
};

export default RightCart;
